export function draftChecklist(draft = {}) {
    const articles = Array.isArray(draft.articles) ? draft.articles : [];
    const articleDetailsComplete = Boolean(articles.length) && articles.every((article) =>
        String(article.problemText || "").trim()
        && Number(article.quantity) > 0
        && String(article.managementCode || "").trim()
    );
    return [
        { id: "customer", label: "Cliente confermato", done: draft.customerConfirmed === true },
        { id: "address", label: "Indirizzo NC scelto", done: Boolean(draft.addressCode) },
        { id: "articles", label: "Articoli associati", done: Boolean(articles.length) },
        { id: "details", label: "Problemi e quantità completi", done: articleDetailsComplete },
    ];
}

export function draftCompletion(draft = {}) {
    const checklist = draftChecklist(draft);
    return Math.round((checklist.filter((item) => item.done).length / checklist.length) * 100);
}

export function draftStorageKey(uid) {
    return `mail-segnalazione:draft:${String(uid || "")}`;
}

export function saveSessionDraft(storage, draft) {
    if (!storage || !draft?.uid) return false;
    try {
        storage.setItem(draftStorageKey(draft.uid), JSON.stringify({ draft, savedAt: new Date().toISOString() }));
        return true;
    } catch (_error) {
        return false;
    }
}

export function loadSessionDraft(storage, uid) {
    if (!storage || !uid) return null;
    try {
        const saved = JSON.parse(storage.getItem(draftStorageKey(uid)) || "null");
        return saved?.draft?.uid === String(uid) ? saved : null;
    } catch (_error) {
        return null;
    }
}

export function clearSessionDraft(storage, uid) {
    try {
        if (storage && uid) storage.removeItem(draftStorageKey(uid));
    } catch (_error) {
        // La bozza resta utilizzabile anche se lo storage del browser non è disponibile.
    }
}
